import React, { useContext } from 'react';
import Form from 'react-bootstrap/Form';
import { DataContext } from './../App';

export default function Baujahr() {
  const { selectedYear, setYear } = useContext(DataContext);

  let years = [];
  for (let i = new Date().getFullYear(); i >= 1850; i--) {
    years.push(i);
  }
  return (
    <Form.Select
      aria-label='Default select example'
      value={selectedYear}
      onChange={(e) => setYear(e.target.value)}
    >
      {years.map((year) => (
        <option value={year} key={year}>
          {year}
        </option>
      ))}
    </Form.Select>
  );
}
